import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_2 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_3 = { class: "text-start w-70px" }
const _hoisted_4 = { class: "w-70px text-end" }
const _hoisted_5 = { class: "min-w-60px text-end" }
const _hoisted_6 = { class: "min-w-40px text-end" }
const _hoisted_7 = { class: "min-w-60px text-end" }
const _hoisted_8 = { class: "min-w-60px text-end" }
const _hoisted_9 = { class: "min-w-40px text-end" }
const _hoisted_10 = { class: "min-w-60px text-end" }
const _hoisted_11 = { class: "min-w-60px text-end" }
const _hoisted_12 = { class: "min-w-60px text-end" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = { class: "text-end" }
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = { class: "text-end" }
const _hoisted_23 = {
  key: 0,
  class: "text-end"
}
const _hoisted_24 = {
  key: 1,
  class: "text-end"
}

import { ref, onMounted, watch } from "vue";
import AccountOverviewService from "@/projects/tenant/views/accountOverview/services/AccountOverviewServices";
import i18n from "@/core/plugins/i18n";
import { handleTradeBuySellDisplay } from "@/core/helpers/helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'accountTrade',
  props: {
  account: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const isLoading = ref(false);
const data = ref<any>([]);
const { t } = i18n.global;



const criteria = ref({
  size: 10,
  accountId: props.account.id,
  accountNumber: props.account.accountNumber,
  serviceId: props.account.serviceId,
} as any);

const fetchData = async (_page: number) => {
  if (
    props.account.accountNumber === 0 ||
    props.account.accountNumber === undefined
  )
    return;
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const res = await AccountOverviewService.queryTrades(criteria.value);
    criteria.value = res.criteria;
    // data.value = res;
    data.value = res.data.map((item: any) => ({
      ticket: item.ticket,
      symbol: item.symbol,
      tp: item.tp,
      volume: item.volume,
      profit: item.profit,
      openTime: item.openAt,
      closeTime: item.closeAt,
      openPrice: item.openPrice,
      closePrice: item.closePrice,
      buySell: t(`type.cmd.${handleTradeBuySellDisplay(item)}`),
    }));
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

watch(
  () => props.account,
  (newAccount, oldAccount) => {
    if (newAccount && newAccount.id !== oldAccount?.id) {
      resetCriteria();
      fetchData(1);
    }
  },
  { deep: true }
);

const resetCriteria = () => {
  criteria.value = {
    size: 10,
    accountId: props.account.id,
    accountNumber: props.account.accountNumber,
    serviceId: props.account.serviceId,
  };
};

onMounted(() => {
  fetchData(1);
});

const pageChange = (page: number) => {
  criteria.value.page = page;
  fetchData(page);
};

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_2, [
          _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t("fields.ticket")), 1),
          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t("fields.tp")), 1),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t("fields.symbol")), 1),
          _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("fields.buy/Sell")), 1),
          _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("fields.openPrice")), 1),
          _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("fields.openTime")), 1),
          _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.volume")), 1),
          _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.profit")), 1),
          _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.closePrice")), 1),
          _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("fields.closeTime")), 1)
        ])
      ]),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
            _createVNode(_component_LoadingRing)
          ]))
        : (!isLoading.value && data.value.length === 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
              _createVNode(_component_NoDataBox)
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (transaction, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "text-center",
                  key: index
                }, [
                  _createElementVNode("td", _hoisted_16, _toDisplayString(transaction.ticket), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(transaction.tp), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(transaction.symbol), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(transaction.buySell), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(transaction.openPrice), 1),
                  _createElementVNode("td", _hoisted_21, [
                    _createVNode(_component_TimeShow, {
                      "date-iso-string": transaction.openTime
                    }, null, 8, ["date-iso-string"])
                  ]),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(transaction.volume), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(["text-end", {
            'text-success': transaction.profit >= 0,
            'text-danger': transaction.profit < 0,
          }])
                  }, _toDisplayString(transaction.profit), 3),
                  (transaction.closePrice != null)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(transaction.closePrice), 1))
                    : _createCommentVNode("", true),
                  (transaction.closeTime != null)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": transaction.closeTime
                        }, null, 8, ["date-iso-string"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
    ]),
    _createVNode(_component_TableFooter, {
      onPageChange: pageChange,
      criteria: criteria.value
    }, null, 8, ["criteria"])
  ], 64))
}
}

})